"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const resize_observer_1 = require("@juggle/resize-observer");
const ResizeObserver = window.ResizeObserver || resize_observer_1.ResizeObserver;
const inPageNavigation = document.querySelector('[data-gs1-inpagenavigation]');
const allContentElementsInContentSection = document.querySelectorAll('[id^=\'c\']');
const subMenuList = Array.from(document.querySelectorAll('.tabs__menu-item--subpages'));
const inPageContainerId = document.querySelector('[data-gs1-inpagenavigation-eluid]')?.getAttribute('data-gs1-inpagenavigation-eluid');
const inPageContainer = document.getElementById(`c${inPageContainerId}`);
const mobileCheck = document.querySelector('.mobile-check');
const mobileCheckContainer = document.querySelector('.localnavigation--horizontal-mobile');
const localNavigationLeft = document.querySelector('.localnavigation--vertical');
if (mobileCheckContainer) {
    mobileCheckContainer.addEventListener("click", (event) => {
        if (inPageNavigation) {
            (mobileCheck.checked) ? inPageNavigation.parentElement.classList.remove('mobile') : inPageNavigation.parentElement.classList.add('mobile');
        }
        if (localNavigationLeft) {
            (mobileCheck.checked) ? localNavigationLeft.classList.remove('mobile') : localNavigationLeft.classList.add('mobile');
        }
    });
}
if (inPageNavigation && inPageContainer) {
    const stageElement = document.querySelector('#stage');
    const navElement = document.querySelector('nav.no-margin');
    if (stageElement) {
        stageElement.style.position = 'sticky';
        stageElement.style.zIndex = '3';
        const resizeObserver = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
                const heroImage = entry.contentRect;
                stageElement.style.top = `-${heroImage.height}px`;
            });
            return;
        });
        resizeObserver.observe(stageElement.children[0]);
    }
    else if (navElement) {
        // Handles cases on SEA LPs
        if (navElement.children.length <= 1) {
            navElement.style.position = 'sticky';
            navElement.style.top = '0px';
            navElement.style.zIndex = '4';
        }
        else {
            // Handles cases on IFS pages where the header is located in the same nav container (nav.nomargin).
            navElement.insertAdjacentElement("afterend", navElement.children[1]);
            navElement.style.position = 'sticky';
            navElement.style.top = '0px';
            navElement.style.zIndex = '3';
        }
    }
    else {
        if (inPageContainer.parentElement.classList.contains('frame-type-shortcut')) {
            inPageContainer.parentElement.style.position = 'sticky';
            inPageContainer.parentElement.style.top = '0px';
            inPageContainer.parentElement.style.zIndex = '3';
        }
        else {
            inPageContainer.style.position = 'sticky';
            inPageContainer.style.top = '0px';
            inPageContainer.style.zIndex = '4';
        }
    }
    let navigationItems = [];
    allContentElementsInContentSection.forEach((item) => {
        (item.parentElement.getAttribute('id') === 'main') ? navigationItems.push(item) : '';
    });
    if (subMenuList) {
        subMenuList.forEach((subMenu) => {
            subMenu.addEventListener("click", (event) => {
                const el = event.target;
                const navList = (window.innerWidth <= 992) ? el.closest('.tabs__menu-item--subpages').querySelector('.mobile-only') : el.closest('.tabs__menu-item--subpages').querySelector('.desktop-only');
                const navButton = el.closest('.tabs__menu-item--subpages').querySelector('.tabs__menu-item--subpages-button');
                (navList.classList.contains('hidden')) ? navList.classList.remove('hidden') : navList.classList.add('hidden');
                (!navList.classList.contains('hidden')) ? navButton.classList.add('tabs__menu-item--subpages-button--open') : navButton.classList.remove('tabs__menu-item--subpages-button--open');
            });
        });
    }
    inPageNavigation.addEventListener("click", (event) => {
        const el = event.target;
        const hash = el.hash;
        if (hash !== undefined && hash !== "") {
            let url = '';
            let urlprefix = location.pathname || '';
            if (urlprefix !== '') {
                url = url + urlprefix;
            }
            url = url + hash;
            history.pushState(null, null, url);
            let targetElement = document.querySelector(hash);
            if (targetElement) {
                event.preventDefault();
                targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                });
            }
        }
    });
    if (window.innerWidth <= 575) {
        const navItems = Array.from(document.querySelectorAll('.tabs__menu-item'));
        navItems.forEach((navItem) => {
            navItem.addEventListener("click", (event) => {
                const el = event.target;
                (!el.parentElement.parentElement.parentElement.classList.contains('mobile') && !el.classList.contains('tabs__menu-item--subpages-button')) ? el.parentElement.parentElement.parentElement.classList.add('mobile') : '';
                mobileCheck.checked = false;
            });
        });
        if (window.scrollY === 0) {
            const mobileCheckLabel = document.querySelector('.mobile-check-label');
            mobileCheckLabel.addEventListener("click", (event) => {
                mobileCheckContainer.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "start"
                });
            });
        }
    }
    const observerOptions = {
        root: document,
        rootMargin: '-25% 0px -75% 0px',
        threshold: 0,
    };
    if (inPageContainer.parentElement.classList.contains('frame-type-shortcut') === false) {
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const elementId = entry.target.id;
                const inPageNavElement = document.querySelector(`a[href$="#${elementId}"]`);
                if (inPageNavElement) {
                    (window.innerHeight >= entry.intersectionRect.top / 2 && entry.isIntersecting) ?
                        (inPageNavElement.parentElement && !inPageNavElement.classList.contains('btn')) ?
                            inPageNavElement.parentElement.classList.add('tabs__menu-item--active') : '' : inPageNavElement.parentElement.classList.remove('tabs__menu-item--active');
                }
            });
        }, observerOptions);
        allContentElementsInContentSection.forEach((section) => {
            sectionObserver.observe(section);
        });
    }
}
exports.default = {};
